import { CATEGORY_ROUTE_PREFIX } from '~/constants';

const getPromotionsCategoryLink = () => {
  return `/${CATEGORY_ROUTE_PREFIX}/promotions`;
};

export default getPromotionsCategoryLink;
